const PrintIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 17.4H4a2 2 0 0 1-2-2v-4.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4.5a2 2 0 0 1-2 2h-2"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 9.3V3.9a.9.9 0 0 1 .9-.9h10.2a.9.9 0 0 1 .9.9v5.4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 13.8h10s1 0 1 .9v5.4s0 .9-1 .9H7s-1 0-1-.9v-5.4s0-.9 1-.9Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PrintIcon;
